import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=12147a93"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=12147a93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports